import { Checkbox, Dialog, DialogContent, FormControlLabel } from '@mui/material';
import { GeneralHelper } from '../../../helpers/GeneralHelper';
import Button from '@mui/material/Button';
import { PaymentsEftRecordStatus } from '../../../models/DeprecatedEnums';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

interface RecordDetailsComponentProps {
  selectedRecord: any;
  show: boolean;
  toggleDialog: (show: boolean) => void;
}



const RecordDetailsComponent = (props: RecordDetailsComponentProps) => {
  const { selectedRecord, show, toggleDialog } = props;
  const isPopReceived: boolean = selectedRecord.popReceived === 'true';

  return (
    <Dialog open={show} onClose={() => toggleDialog(false)} maxWidth={'md'} fullWidth={true}>
      <DialogContent>
        {selectedRecord && (
          <div style={{ height: 600 }}>
            <Grid container direction="row" justifyContent="space-between" alignItems="left">
              <Grid item>
                <Typography variant={'h5'}>Record #{selectedRecord.id}</Typography>
              </Grid>
              <Grid item>All details for Bank Statement Record.</Grid>
            </Grid>
            <Grid container spacing={2} sx={{ mt: 2 }}>
              <Grid item md={3}>
                <Typography variant={'body2'}>Type</Typography>
                <Typography variant={'subtitle1'}>
                  <strong>{selectedRecord.recordType}</strong>
                </Typography>
              </Grid>
              `
              <Grid item md={3}>
                <Typography variant={'body2'}>Status</Typography>
                <Typography variant={'subtitle1'}>
                  <strong>{selectedRecord.status}</strong>
                </Typography>
              </Grid>
              <Grid item md={3}>
                <Typography variant={'body2'}>Transaction Date</Typography>
                <Typography variant={'subtitle1'}>
                  <strong>{GeneralHelper.formatDate(selectedRecord.transactionDate.toString())}</strong>
                </Typography>
              </Grid>
              <Grid item md={3}>
                <Typography variant={'body2'}>Amount</Typography>
                <Typography variant={'subtitle1'}>
                  <strong>{GeneralHelper.formatCurrency(selectedRecord.amount)}</strong>
                </Typography>
              </Grid>
              {selectedRecord.status === PaymentsEftRecordStatus.ERROR && (
                <Grid item md={3}>
                  <Typography variant={'body2'}>Proxima response</Typography>
                  <Typography variant={'subtitle1'}>
                    <strong>{selectedRecord.promixaResponse}</strong>
                  </Typography>
                </Grid>
              )}
              <Grid item md={3}>
                <Typography variant={'body2'}>Referenced Used</Typography>
                <Typography variant={'subtitle1'}>
                  <strong>{selectedRecord.referenceUsed}</strong>
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ mt: 2 }}>
              <Grid item md={3}>
                <Typography variant={'body2'}>Member Id</Typography>
                <Typography variant={'subtitle1'}>
                  <strong>{selectedRecord.memberId}</strong>
                </Typography>
              </Grid>
              <Grid item md={3}>
                <Typography variant={'body2'}>Member name</Typography>
                <Typography variant={'subtitle1'}>
                  <strong>{selectedRecord.memberName}</strong>
                </Typography>
              </Grid>
              <Grid item md={3}>
                <Typography variant={'body2'}>Member email address</Typography>
                <Typography variant={'subtitle1'}>
                  <strong>{selectedRecord.memberEmail}</strong>
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ mt: 2 }}>
              <Grid item md={3}>
                <Typography variant={'body2'}>Description 1</Typography>
                <Typography variant={'subtitle1'}>
                  <strong>{selectedRecord.originalDescription1}</strong>
                </Typography>
              </Grid>
              <Grid item md={3}>
                <Typography variant={'body2'}>Description 2</Typography>
                <Typography variant={'subtitle1'}>
                  <strong>{selectedRecord.originalDescription2}</strong>
                </Typography>
              </Grid>
              <Grid item md={6}>
                <Typography variant={'body2'}>Original detail</Typography>
                <Typography variant={'subtitle1'}>
                  <strong>{selectedRecord.originalRecord}</strong>
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ mt: 2 }}>
              <Grid item md={5}>
                <FormControlLabel
                  className="profile-ud-label"
                  control={<Checkbox checked={isPopReceived} />}
                  label="Proof of Payment Received"
                />
              </Grid>
              {isPopReceived && selectedRecord.popReceivedBy && (
                <Grid item md={3}>
                  <Typography variant={'body2'}>Pop received by</Typography>
                  <Typography variant={'subtitle1'}>
                    <strong>{selectedRecord.popReceivedName}</strong>
                  </Typography>
                </Grid>
              )}
              {isPopReceived && selectedRecord.popReceivedAt && (
                <Grid item md={3}>
                  <Typography variant={'body2'}>Pop received at</Typography>
                  <Typography variant={'subtitle1'}>
                    <strong>{GeneralHelper.formatDate(selectedRecord.popReceivedAt)}</strong>
                  </Typography>
                </Grid>
              )}
              <Grid item md={5}>
                <Button variant={'outlined'} color="inherit" onClick={() => toggleDialog(false)}>
                  Close
                </Button>
              </Grid>
            </Grid>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default RecordDetailsComponent;
